<template>
   <div class="container">
     <div id="box-container">
       <div class='boxes box1'></div>
       <div class='boxes box2'></div>
       <div class='boxes box3'></div>
     </div>
     <div class="text  ">
     </div>
   </div>
</template>
<script setup>

</script>